import Asterisk from '../Asterisk/Asterisk';
import React, { useLayoutEffect, useRef, useState, useMemo, useEffect } from 'react';
import { FormGroup, Label, Input } from '../tempImports/reactstrap';
import { CountrySelect } from '../../modules/CountrySelect/CountrySelect';
import EventLabel from '../EventLabel/EventLabel';
import { useStore } from '../../store/Store';
import PhoneNumberField from '../PhoneNumberField/PhoneNumberField';
import { twMerge } from 'tailwind-merge';
import { observer } from 'mobx-react-lite';

const CustomInput = props => {
  const {
    onChange,
    type,
    noMargin = false,
    prefixClassName = undefined,
    staticLabel = false,
    displayType = 'short',
    label,
    value,
    subLabel,
    disabled = false,
    noLabel = false,
    noInputField = false,
    lang,
    readonly,
    valid,
    required,
    onKeyDown,
    eventId,
    appendButton = null,
    validationError = false,
    onBlur,
    onFocus,
    invoice = false,
    onClick,
    placeholder,
    showConfirmInput = false,
    confirmInputValue = '',
    confirmInputOnChange,
    autocomplete = null,
    settings,
    setUserInteracted,
  } = props;
  const store = useStore();
  const inputRef = useRef(null);
  const btnWrapRef = useRef(null);
  const [btnPos, setBtnPos] = useState(0);

  const inputCssId = useMemo(() => {
    if (settings?.fieldId) {
      return 'field-' + settings?.fieldId;
    } else if (settings?.questionId) {
      return 'question-' + settings?.questionId;
    } else return null;
  }, [settings]);

  useLayoutEffect(() => {
    if (inputRef.current && btnWrapRef.current) {
      let inputWidth = inputRef.current.getBoundingClientRect().width;
      let marginLeft = parseFloat(getComputedStyle(inputRef.current).marginLeft.replace('px', ''));
      let btnWidth = btnWrapRef.current.getBoundingClientRect().width;
      let pos = inputWidth + (marginLeft ?? 0) - btnWidth - 5;
      if (Math.abs(btnPos - pos) > 1) {
        setBtnPos(pos);
      }
    }
  });


  const autoCompleteType = autocomplete || type;
  const inputProps = {
    type: noInputField ? 'hidden' : displayType == 'long' ? 'textarea' : 'text',
    disabled,
    readOnly: readonly,
    className: prefixClassName + `${validationError ? ' validation-error' : ''}`,
    ['aria-label']: label,
    name: label,
    autoComplete: autoCompleteType,
    value,
    settings,
    onChange,
    onKeyDown: typeof onKeyDown === 'function' ? e => onKeyDown({ ...e }) : undefined,
    onBlur: typeof onBlur === 'function' ? e => onBlur({ ...e }) : undefined,
    onFocus: typeof onFocus === 'function' ? e => onFocus({ ...e }) : undefined,
    placeholder: placeholder ? placeholder : undefined,
    onClick: typeof onClick === 'function' ? e => onClick({ ...e }) : undefined,
    id: inputCssId,
  };

  useEffect(() => {
    if (!value && type == 'CountryId' && store?.environment?.defaultCountry) {
      onChange(store?.environment?.defaultCountry);
    }
  }, [type, store?.environment?.defaultCountry, value, onChange]);

  return (
    <>
      <FormGroup className={twMerge(prefixClassName, noMargin ? 'm-0' : '', 'w-full mb-4')}>
        {!noLabel && !settings?.hideLabel ? (
          <div className={`title-holder ${validationError ? 'validation-error' : ''}`}>
            {staticLabel ? (
              <Label className={prefixClassName} for={inputCssId}>
                {label && <EventLabel name={label} groupName={'Content.StaticLabels'} />}
                {required ? <Asterisk /> : null}
              </Label>
            ) : (
              <Label className={prefixClassName + ' flex'} for={inputCssId}>
                {label}
                {required ? <Asterisk /> : null}
              </Label>
            )}
            {subLabel ? (
              <Label className="sublabel" for={inputCssId}>
                {subLabel}
              </Label>
            ) : null}
          </div>
        ) : null}
        {appendButton ? (
          <>
            <Input
              onInput={e => {
                setUserInteracted?.(true);
              }}
              innerRef={inputRef}
              style={{ border: valid === false ? '1px solid #d53443' : undefined }}
              {...inputProps}
            />
            {appendButton}
          </>
        ) : type == 'CountryCode' || type == 'CountryId' ? (
          <CountrySelect
            prefixClassName={prefixClassName}
            onChange={onChange}
            value={value || store?.defaultSelectedCountry}
            type={'CountryId'}
            eventId={eventId}
            lang={lang}
          />
        ) : type === 'Telephone1' || type === 'Telephone2' || type === 'Telephone3' ? (
          <PhoneNumberField {...inputProps} cssId={props?.cssId} valid={valid} invoice={invoice} />
        ) : (
          <Input
            onInput={e => {
              setUserInteracted?.(true);
            }}
            className="w-full"
            innerRef={inputRef}
            style={{ border: valid === false ? '1px solid #d53443' : undefined }}
            {...inputProps}
          />
        )}
      </FormGroup>
      {showConfirmInput ? (
        <ConfirmationInput
          {...inputProps}
          prefixClassName={prefixClassName}
          parentLabel={type}
          valid={valid}
          confirmInputOnChange={confirmInputOnChange}
          confirmInputValue={confirmInputValue}
        />
      ) : null}
    </>
  );
};

const ConfirmationInput = ({ disabled, readOnly, valid, prefixClassName, parentLabel, confirmInputOnChange, confirmInputValue }) => {
  return (
    <FormGroup className={prefixClassName + ' form-group mb-4'}>
      <div className="title-holder">
        <Label className="flex" for={'email-confirm-input'}>
          <EventLabel name={'Confirm' + parentLabel} groupName={'Content.StaticLabels'} />
          <Asterisk />
        </Label>
      </div>
      <Input
        {...{
          disabled,
          readOnly,
          value: confirmInputValue,
          onChange: confirmInputOnChange,
        }}
        id={'email-confirm-input'}
        style={{ border: valid === false ? '1px solid #d53443' : undefined }}
      />
    </FormGroup>
  );
};
export default observer(CustomInput);
